module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_6000.1de84212.png";